<template>
  <div class="w-full">
    <div
      class="flex flex-wrap items-center justify-between w-full gap-4 px-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm"
    >
    <!-- Range summary -->
    <div class="text-sm text-gray-500 whitespace-no-wrap">
      Showing
      <span class="font-semibold text-gray-800">{{ start }}</span>
      –
      <span class="font-semibold text-gray-800">{{ end }}</span>
      of
      <span class="font-semibold text-gray-800">{{ count }}</span>
      <span class="ml-1 text-xs text-gray-400">(page {{ currentPage }} of {{ total }})</span>
    </div>

    <!-- Per page -->
    <div class="flex items-center space-x-2 text-sm text-gray-500 whitespace-no-wrap">
      <label for="perPage">Rows per page</label>
      <select
        class="h-9 py-0 text-sm text-gray-800 border-gray-300 shadow-sm form-select rounded-lg focus:border-taxiye-300"
        name="perPage"
        id="perPage"
        v-model="perPage"
        @change="$emit('setPerPage', perPage)"
      >
        <option :selected="perPage === '10'" value="10">10</option>
        <option :selected="perPage === '25'" value="25">25</option>
        <option :selected="perPage === '50'" value="50">50</option>
        <option :selected="perPage === '100'" value="100">100</option>
      </select>
    </div>

    <!-- Page buttons -->
    <div class="flex items-center space-x-1">
      <button
        @click="$emit('goto', 1)"
        type="button"
        title="First page"
        class="flex items-center justify-center h-9 w-9 text-gray-400 rounded-lg transition-colors duration-150 hover:bg-gray-100 hover:text-gray-700 focus:outline-none"
      >
        <i class="text-xl material-icons-round">first_page</i>
      </button>
      <button
        @click="$emit('goto', currentPage == 1 ? 1 : parseInt(currentPage) - 1)"
        type="button"
        title="Previous page"
        class="flex items-center justify-center h-9 w-9 text-gray-400 rounded-lg transition-colors duration-150 hover:bg-gray-100 hover:text-gray-700 focus:outline-none"
      >
        <i class="text-xl material-icons-round">chevron_left</i>
      </button>
      <span v-for="page in paginationPages" :key="`pageLink-${page}`">
        <button
          v-if="page !== '-'"
          type="button"
          class="h-9 w-9 text-sm rounded-lg transition-colors duration-150 focus:outline-none"
          :class="
            currentPage == page
              ? 'font-semibold text-white bg-taxiye-500 shadow-sm'
              : 'text-gray-500 hover:bg-gray-100 hover:text-gray-800'
          "
          :disabled="currentPage === page"
          @click="$emit('goto', page)"
        >
          {{ page }}
        </button>
        <span
          v-else
          class="flex items-center justify-center h-9 w-9 text-gray-400"
        >
          …
        </span>
      </span>
      <button
        @click="
          $emit(
            'goto',
            parseInt(currentPage) + 1 <= parseInt(total)
              ? parseInt(currentPage) + 1
              : parseInt(currentPage)
          )
        "
        type="button"
        title="Next page"
        class="flex items-center justify-center h-9 w-9 text-gray-400 rounded-lg transition-colors duration-150 hover:bg-gray-100 hover:text-gray-700 focus:outline-none"
      >
        <i class="text-xl material-icons-round">chevron_right</i>
      </button>
      <button
        @click="$emit('goto', parseInt(total))"
        type="button"
        title="Last page"
        class="flex items-center justify-center h-9 w-9 text-gray-400 rounded-lg transition-colors duration-150 hover:bg-gray-100 hover:text-gray-700 focus:outline-none"
      >
        <i class="text-xl material-icons-round">last_page</i>
      </button>
    </div>

    <!-- Jump to page -->
    <div class="flex items-center">
      <input
        type="number"
        min="1"
        class="w-20 h-9 px-3 text-sm text-gray-800 border border-gray-300 shadow-sm rounded-l-lg focus:outline-none focus:border-taxiye-300"
        placeholder="Page #"
        title="Jump to page"
        v-model="pageToJumpInto"
        @keyup.enter="$emit('goto', pageToJumpInto)"
      />
      <button
        class="h-9 px-4 text-sm font-semibold text-white transition-colors duration-150 bg-taxiye-500 rounded-r-lg shadow-sm hover:bg-taxiye-400 focus:outline-none"
        @click="$emit('goto', pageToJumpInto)"
      >
        Jump
      </button>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentPage", "total", "perPage", "start", "end", "count"],
  data() {
    return {
      pageToJumpInto: "",
    };
  },
  computed: {
    paginationPages() {
      const paginationLimit = 11;

      const curr = parseInt(this.currentPage);
      const total = parseInt(this.total);

      if (curr < paginationLimit / 2) {
        return Array(total > paginationLimit ? paginationLimit : total)
          .fill(undefined)
          .map((_, i) => i + 1);
      } else if (total - curr < paginationLimit) {
        return Array(total > paginationLimit ? paginationLimit : total)
          .fill(total - (total > paginationLimit ? paginationLimit : total))
          .map((x, i) => x + i + 1);
      } else {
        return Array(paginationLimit)
          .fill(curr - Math.ceil(paginationLimit / 2))
          .map((x, i) => x + i + 1);
      }
    },
  },
};
</script>
